export default "__VITE_ASSET__1f61e475__"